export const setGoal = (goal) => ({
  type: "SET_GOAL",
  payload: goal,
});

export default setGoal;
